{********************************************************************}
{ written by TMS Software                                            }
{            copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCDataGridColumnsEditor;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, Types, UITypes, WEBLib.Forms, WEBLib.TMSFNCTypes,
  {$IFDEF FMXLIB}
  FMX.Types,
  {$ENDIF}
  WEBLib.TMSFNCCustomDialog, WEBLib.TMSFNCEditorPanel, WEBLib.TMSFNCTreeViewData,
  WEBLib.TMSFNCEditorButton, WEBLib.TMSFNCCheckedListBox, WEBLib.TMSFNCDataGridRenderer;

resourcestring
  sTMSFNCDataGridColumnsEditorUILanguageClose = 'Close';

type
  TTMSFNCDataGridColumnsEditorUILanguage = class(TPersistent)
  private
    FClose: string;
    FOnInternalChanged: TNotifyEvent;
    function IsCloseStored: Boolean;
  protected
    procedure DoChanged;
  public
    constructor Create;
    procedure Assign(Source: TPersistent); override;
    property OnInternalChanged: TNotifyEvent read FOnInternalChanged write FOnInternalChanged;
  published
    property Close: string read FClose write FClose stored IsCloseStored;
  end;

  TTMSFNCDataGridColumnsEditorMode = (gcemVisibleOnly, gcemAll);

  TTMSFNCDataGridColumnsEditorOptions = class(TPersistent)
  private
    FOwner: TComponent;
    FUILanguage: TTMSFNCDataGridColumnsEditorUILanguage;
    FMode: TTMSFNCDataGridColumnsEditorMode;
    FEnableDragDrop: Boolean;
    procedure SetUILanguage(const Value: TTMSFNCDataGridColumnsEditorUILanguage);
    procedure SetEnableDragDrop(const Value: Boolean);
    procedure SetMode(const Value: TTMSFNCDataGridColumnsEditorMode);
  public
    constructor Create(AOwner: TComponent);
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
  published
    property UILanguage: TTMSFNCDataGridColumnsEditorUILanguage read FUILanguage write SetUILanguage;
    property Mode: TTMSFNCDataGridColumnsEditorMode read FMode write SetMode default gcemVisibleOnly;
    property EnableDragDrop: Boolean read FEnableDragDrop write SetEnableDragDrop default True;
  end;

  TTMSFNCCustomDataGridColumnsEditor = class(TTMSFNCCustomDialog)
  private
    FPanel, FBottomPanel: TTMSFNCEditorPanel;
    FButtonClose: TTMSFNCEditorButton;
    FListBox: TTMSFNCCheckedListBox;
    FModified: Boolean;
    FOptions: TTMSFNCDataGridColumnsEditorOptions;
    FRenderer: TTMSFNCDataGridRenderer;
    procedure SetOptions(const Value: TTMSFNCDataGridColumnsEditorOptions);
    procedure SetRenderer(const Value: TTMSFNCDataGridRenderer);
  protected
    function GetInstance: NativeUInt; override;
    procedure DoNotifyEditor(Sender: TObject);
    procedure DoButtonCloseClick(Sender: TObject);
    procedure DoListBoxGetNodeData(Sender: TObject; ANode: TTMSFNCTreeViewVirtualNode);
    procedure DoListBoxItemCheckChanged(Sender: TObject; AItem: TTMSFNCCheckedListBoxItem);
    procedure DoListBoxGetNodeCheckType(Sender: TObject; ANode: TTMSFNCTreeViewVirtualNode; AColumn: Integer; var ACheckType: TTMSFNCTreeViewNodeCheckType);
    procedure DoListBoxDragOver(Sender: TObject; Source: TObject; Point: TPointF; var Accept: Boolean);
    procedure DoListBoxDragDrop(Sender: TObject; Source: TObject; Point: TPointF);
    procedure BuildDialog(AParent: TTMSFNCCustomDialogParent); override;
    property Options: TTMSFNCDataGridColumnsEditorOptions read FOptions write SetOptions;
    property Renderer: TTMSFNCDataGridRenderer read FRenderer write SetRenderer;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    procedure UpdateList;
    procedure Assign(Source: TPersistent); override;
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil; AModal: Boolean = True); override;
    {$ELSE}
    function Execute(AModal: Boolean = True): TModalResult; override;
    {$ENDIF}
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWebDesktop)]
  {$ENDIF}
  TTMSFNCDataGridColumnsEditor = class(TTMSFNCCustomDataGridColumnsEditor)
  public
    property Renderer;
  published
    property Options;
    property OnClose;
  end;

implementation

uses
  WEBLib.TMSFNCDataGrid, WEBLib.TMSFNCCustomControl, Math, SysUtils,
  WEBLib.Controls, WEBLib.Graphics, WEBLib.TMSFNCListBox, WEBLib.TMSFNCEditorsTools, WEBLib.TMSFNCUtils;

type
  TTMSFNCCustomDialogEx = class(TTMSFNCCustomDialog);
  TCustomFormOpen = class(TCustomForm);
  TTMSFNCListBoxOpen = class(TTMSFNCCheckedListBox);
  TTMSFNCDataGridRendererOpen = class(TTMSFNCDataGridRenderer);

{ TTMSFNCCustomDataGridColumnsEditor }

procedure TTMSFNCCustomDataGridColumnsEditor.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCCustomDataGridColumnsEditor) then
    FOptions.Assign((Source as TTMSFNCCustomDataGridColumnsEditor).Options)
  else
    inherited;

  FModified := True;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCCustomDataGridColumnsEditor.Execute(AProc: TModalResultProc = nil; AModal: Boolean = True);
{$ELSE}
function TTMSFNCCustomDataGridColumnsEditor.Execute(AModal: Boolean = True): TModalResult;
{$ENDIF}
begin
  if not Assigned(FRenderer) then
  begin
    {$IFDEF WEBLIB}
    AProc(mrAbort);
    {$ELSE}
    Result := mrAbort;
    {$ENDIF}
    Exit;
  end;

  {$IFDEF WEBLIB}
  inherited;
  {$ELSE}
  Result := inherited;
  {$ENDIF}
  UpdateList;
end;

procedure TTMSFNCCustomDataGridColumnsEditor.BuildDialog(AParent: TTMSFNCCustomDialogParent);
begin
  inherited;

  if AParent is TCustomForm then
  begin
    {$IFDEF FMXLIB}
    TCustomFormOpen(AParent).FormStyle := TFormStyle.StayOnTop;
    TCustomFormOpen(AParent).Position := TFormPosition.MainFormCenter;
    {$ELSE}
    TCustomFormOpen(AParent).FormStyle := fsStayOnTop;
    {$IFDEF VCLLIB}
    TCustomFormOpen(AParent).Position := poMainFormCenter;
    {$ENDIF}
    {$ENDIF}
  end;

  FPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FPanel.Align := TAlignLayout.Client;
  FPanel.PanelPosition := eppCenter;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPanel.PanelPosition := eppCenter;
  FPanel.Align := alClient;
  {$ENDIF}
  FPanel.Parent := AParent;

  SetEditorSubPanelAppearance(FPanel);

  FListBox := TTMSFNCCheckedListBox.Create(AParent);
  FListBox.ControlAlignment := caClient;
  FListBox.Parent := AParent;
  FListBox.OnItemCheckChanged := DoListBoxItemCheckChanged;
  FListBox.TreeView.OnGetNodeData := DoListBoxGetNodeData;
  FListBox.TreeView.OnCustomDragOver := DoListBoxDragOver;
  FListBox.TreeView.OnCustomDragDrop := DoListBoxDragDrop;
  FListBox.TreeView.OnGetNodeCheckType := DoListBoxGetNodeCheckType;

  FListBox.ItemsAppearance.HeightMode := lihmVariable;
  if Options.FEnableDragDrop then
    FListBox.Interaction.DragDropMode := ldmMove
  else
    FListBox.Interaction.DragDropMode := ldmNone;

  FBottomPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FBottomPanel.Align := TAlignLayout.Bottom;
  FBottomPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FBottomPanel.PanelPosition := eppCenter;
  FBottomPanel.Align := alBottom;
  {$ENDIF}
  FBottomPanel.Parent := AParent;

  FBottomPanel.Height := 37;
  SetEditorBackPanelAppearance(FBottomPanel);

  FButtonClose := TTMSFNCEditorButton.Create(FBottomPanel);
  FButtonClose.ModalResult := mrClose;
  FButtonClose.Parent := FBottomPanel;
  FButtonClose.Text := FOptions.UILanguage.Close;
  {$IFDEF FMXLIB}
  FButtonClose.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonClose.Align := alRight;
  FButtonClose.Left := 99;
  {$IFDEF VCLWEBLIB}
  FButtonClose.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonClose.BorderSpacing.Right := 5;
  FButtonClose.BorderSpacing.Top := 5;
  FButtonClose.BorderSpacing.Bottom := 5;
  FButtonClose.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonClose.Margins.Right := 5;
  FButtonClose.Margins.Top := 5;
  FButtonClose.Margins.Bottom := 5;
  FButtonClose.Margins.Left := 5;
  {$ENDIF}
  FButtonClose.OnClick := DoButtonCloseClick;
  SetEditorCancelButtonAppearance(FButtonClose);
end;

constructor TTMSFNCCustomDataGridColumnsEditor.Create(AOwner: TComponent);
begin
  inherited;

  DestroyForm := False;

  Caption := 'Columns Editor';

  DialogWidth := 250;
  DialogHeight := 400;

  Sizeable := True;

  FOptions := TTMSFNCDataGridColumnsEditorOptions.Create(Self);

  AllowReturnKeyClose := False;

  FModified := False;
end;

destructor TTMSFNCCustomDataGridColumnsEditor.Destroy;
begin
  FOptions.Free;
  inherited;
end;

procedure TTMSFNCCustomDataGridColumnsEditor.DoButtonCloseClick(Sender: TObject);
var
  cl: Boolean;
begin
  cl := True;
  if cl then
  begin
    Form.ModalResult := mrClose;
    Form.Close;
  end;
end;

procedure TTMSFNCCustomDataGridColumnsEditor.DoListBoxGetNodeCheckType(Sender: TObject; ANode: TTMSFNCTreeViewVirtualNode; AColumn: Integer; var ACheckType: TTMSFNCTreeViewNodeCheckType);
begin
  if Options.Mode = gcemAll then
    ACheckType := tvntCheckBox
  else
    ACheckType := tvntNone;
end;

procedure TTMSFNCCustomDataGridColumnsEditor.DoListBoxDragDrop(Sender: TObject; Source: TObject; Point: TPointF);
var
  r: TTMSFNCDataGridRenderer;
  rl: ITMSFNCDataGridRendererLink;
begin
  if Supports(Source, ITMSFNCDataGridRendererLink, rl) then
  begin
    r := rl.Link;
    if Assigned(r) then
    begin
      TTMSFNCDataGridRendererOpen(r).HideDragCell;
      TTMSFNCDataGridRendererOpen(r).ResetDrag;
    end;

    UpdateList;
  end;
end;

procedure TTMSFNCCustomDataGridColumnsEditor.DoListBoxGetNodeData(Sender: TObject; ANode: TTMSFNCTreeViewVirtualNode);
var
  it: TTMSFNCListBoxItem;
begin
  it := TTMSFNCListBoxOpen(FListBox).GetItemForNode(ANode);
  if Assigned(it) then
  begin
    ANode.DataInteger := it.DataInteger;
    ANode.DataString := it.DataString;
  end;
end;

procedure TTMSFNCCustomDataGridColumnsEditor.DoListBoxItemCheckChanged(
  Sender: TObject; AItem: TTMSFNCCheckedListBoxItem);
begin
  if Assigned(Renderer) then
  begin
    if AItem.Checked then
      Renderer.UnhideColumn(AItem.DataInteger)
    else
      Renderer.HideColumn(AItem.DataInteger);
  end;
end;

procedure TTMSFNCCustomDataGridColumnsEditor.DoListBoxDragOver(Sender: TObject; Source: TObject; Point: TPointF; var Accept: Boolean);
var
  r: TTMSFNCDataGridRenderer;
  rl: ITMSFNCDataGridRendererLink;
begin
  if Supports(Source, ITMSFNCDataGridRendererLink, rl) then
  begin
    r := rl.Link;
    if Assigned(r) then
      Accept := (TTMSFNCDataGridRendererOpen(r).DraggingMode = gdmColumnDragging);
  end;
end;

procedure TTMSFNCCustomDataGridColumnsEditor.DoNotifyEditor(Sender: TObject);
begin
  UpdateList;
end;

function TTMSFNCCustomDataGridColumnsEditor.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

procedure TTMSFNCCustomDataGridColumnsEditor.SetOptions(const Value: TTMSFNCDataGridColumnsEditorOptions);
begin
  FOptions.Assign(Value);
end;

procedure TTMSFNCCustomDataGridColumnsEditor.SetRenderer(
  const Value: TTMSFNCDataGridRenderer);
begin
  FRenderer := Value;
  if Assigned(FRenderer) then
    FRenderer.OnNotifyEditor := DoNotifyEditor;
end;

procedure TTMSFNCCustomDataGridColumnsEditor.UpdateList;
var
  I: Integer;
  it: TTMSFNCListBoxItem;
begin
  if not Assigned(FListBox) then
    Exit;

  FListBox.BeginUpdate;
  FListBox.Items.Clear;
  if Assigned(FRenderer) then
  begin
    for I := 0 to FRenderer.ColumnCount - 1 do
    begin
      if FRenderer.IsColumnHidden(I) or (Options.Mode = gcemAll) then
      begin
        it := FListBox.Items.Add;
        it.DataInteger := I;
        it.DataString := 'columns_editor';
        it.Text := Renderer.Columns[I].DisplayName + '<BR><font color="gcSilver">Index: ' + IntToStr(Renderer.ColumnOrders[I]) + '</font>';
        it.Checked := FRenderer.IsColumnDisplayed(I);
      end;
    end;
  end;
  FListBox.EndUpdate;
end;

{ TTMSFNCDataGridColumnsEditorUILanguage }

procedure TTMSFNCDataGridColumnsEditorUILanguage.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridColumnsEditorUILanguage then
  begin
    FClose := (Source as TTMSFNCDataGridColumnsEditorUILanguage).Close;
  end
  else
    inherited;
end;

procedure TTMSFNCDataGridColumnsEditorUILanguage.DoChanged;
begin
  if Assigned(FOnInternalChanged) then
    FOnInternalChanged(Self);
end;

constructor TTMSFNCDataGridColumnsEditorUILanguage.Create;
begin
  FClose := sTMSFNCDataGridColumnsEditorUILanguageClose;
end;

function TTMSFNCDataGridColumnsEditorUILanguage.IsCloseStored: Boolean;
begin
  Result := FClose <> sTMSFNCDataGridColumnsEditorUILanguageClose;
end;

{ TTMSFNCDataGridColumnsEditorOptions }

procedure TTMSFNCDataGridColumnsEditorOptions.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCDataGridColumnsEditorOptions then
  begin
    FUILanguage.Assign((Source as TTMSFNCDataGridColumnsEditorOptions).UILanguage);
    FMode := (Source as TTMSFNCDataGridColumnsEditorOptions).Mode;
    FEnableDragDrop := (Source as TTMSFNCDataGridColumnsEditorOptions).EnableDragDrop;
  end
  else
    inherited;
end;

constructor TTMSFNCDataGridColumnsEditorOptions.Create(AOwner: TComponent);
begin
  inherited Create;
  FOwner := AOwner;
  FUILanguage := TTMSFNCDataGridColumnsEditorUILanguage.Create;
  FMode := gcemVisibleOnly;
  FEnableDragDrop := True;
end;

destructor TTMSFNCDataGridColumnsEditorOptions.Destroy;
begin
  FUILanguage.Free;
  inherited;
end;

procedure TTMSFNCDataGridColumnsEditorOptions.SetEnableDragDrop(
  const Value: Boolean);
var
  ce: TTMSFNCCustomDataGridColumnsEditor;
begin
  if FEnableDragDrop <> Value then
  begin
    FEnableDragDrop := Value;
    if Assigned(FOwner) and (FOwner is TTMSFNCCustomDataGridColumnsEditor) then
    begin
      ce := FOwner as TTMSFNCCustomDataGridColumnsEditor;
      if Assigned(ce.FListBox) then
      begin
        if FEnableDragDrop then
          ce.FListBox.Interaction.DragDropMode := ldmMove
        else
          ce.FListBox.Interaction.DragDropMode := ldmNone;
      end;

      ce.UpdateList;
    end;
  end;
end;

procedure TTMSFNCDataGridColumnsEditorOptions.SetMode(
  const Value: TTMSFNCDataGridColumnsEditorMode);
var
  ce: TTMSFNCCustomDataGridColumnsEditor;
begin
  if FMode <> Value then
  begin
    FMode := Value;
    if Assigned(FOwner) and (FOwner is TTMSFNCCustomDataGridColumnsEditor) then
    begin
      ce := FOwner as TTMSFNCCustomDataGridColumnsEditor;
      ce.UpdateList;
    end;
  end;
end;

procedure TTMSFNCDataGridColumnsEditorOptions.SetUILanguage(const Value: TTMSFNCDataGridColumnsEditorUILanguage);
begin
  FUILanguage.Assign(Value);
end;

end.
